/* global globalThis */
import { USER_SERVICES } from "Services";
import {
  SUPER_ADMIN,
  SUBSCRIBILI_USER,
  GROUP_ADMIN,
  PARTNER_ADMIN,
  LOCATION_ADMIN,
  REGION_ADMIN,
  REVSHARE_ADMIN,
} from "global-constants/roles";
import { getSelectedCountry } from "utils";
import { PAGE_URLS } from "Routes/Main/constants";

// Parse features from custom:feature attribute (format: "f:onb" or "f:onb,f:feature2")
export const parseUserFeatures = (userAttributes = {}) => {
  const customFeature = userAttributes?.['custom:feature'] || '';
  const features = customFeature
    ? customFeature.split(',').map(f => f.replace('f:', '').trim()).filter(Boolean)
    : [];
  
  return features;
};

export const roleSpecificUserData = async (userInfo, selectedCountry = null) => {
  const country = selectedCountry || getSelectedCountry();

  // Use user-attributes + level metadata returned by auth APIs
  const user_attributes = userInfo?.user_attributes;
  const userDetails = { ...user_attributes };
  const rawRole = userDetails?.['custom:role'] || '';
  const role = rawRole.includes(':')
  ? rawRole.split(':')[1]
  : rawRole;
  
  // Parse and set user features from custom:feature attribute
  const features = parseUserFeatures(user_attributes);
  userDetails.details = { features };
  
  if (role !== SUPER_ADMIN.key && role !== SUBSCRIBILI_USER.key) {
    userDetails.level = userInfo?.user_level || '';
    userDetails.levelId = userInfo?.level_ids?.[0] || '';
    userDetails.level_ids = userInfo?.level_ids || [];
    userDetails.partner_id = userInfo?.partner_id || '';

    if (!userDetails.level || !userDetails.levelId) {
      localStorage.setItem(`userDetail_${country}`, JSON.stringify(userDetails));
      return userDetails;
    }

    try {
      // Directly fetch settings using level and levelId from login response
      const settingsResponse = await USER_SERVICES.getSettings(
        userDetails.level,
        userDetails.levelId,
      );

      if (settingsResponse?.type === 'success' && settingsResponse?.data) {
        const { logo } = settingsResponse?.data?.settings || {};

        if (logo) {
          const { data: logoData = {} } =
            (await USER_SERVICES.getAWSAccessURL(logo.key)) || {};
          logoData.url && (userDetails.logoURL = logoData.url);
        }

        userDetails.settings = settingsResponse.data;
      } else {
        throw settingsResponse;
      }
    } catch (error) {
      console.log(error);
    }
  }

  localStorage.setItem(`userDetail_${country}`, JSON.stringify(userDetails));
  return userDetails;
};

/**
 * Returns the post-login destination.
 * All users are redirected to the new dashboard, regardless of group or role.
 * Exception: local development (localhost) stays on the old dashboard.
 */
export const getPostLoginRedirect = (defaultPath = PAGE_URLS.DASHBOARD) => {
  if (globalThis.location?.hostname === 'localhost') {
    return defaultPath;
  }
  return PAGE_URLS.NEW_DASHBOARD;
};

export const checkIfAdmin = (userInfo) => {
  const role = userInfo?.["custom:role"];

  if (
    role &&
    (role.includes(GROUP_ADMIN.key) ||
      role.includes(PARTNER_ADMIN.key) ||
      role.includes(LOCATION_ADMIN.key) ||
      role.includes(REGION_ADMIN.key) ||
      role.includes(REVSHARE_ADMIN.key))
  ) {
    return true;
  }
  return false;
};
